import { ReactComponent } from './number-1-xs.svg';
export const Number1IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-1-xs.js.map